// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import * as React from 'react';
import Button from 'react-bootstrap/lib/Button';

import colors from '../config/colors';
import { DesktopView, MobileView } from '../config/mediaQuery';

type Props = {
  onConfirm: any => mixed,
  onCancel: () => mixed,
  message: string,
  cancelText?: string,
  confirmText?: string,
  hideActions?: boolean,
  errorMessage?: string,
};

export default class Prompt extends React.PureComponent<Props> {
  static defaultProps = {
    cancelText: 'Cancel',
    confirmText: 'Confirm',
    hideActions: false,
  };

  render() {
    return (
      <MobileView>
        {(isMobile) => (
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              zIndex: 10,
            }}
          >
            <p
              css={{
                color: 'white',
                fontSize: '16px',
              }}
            >
              {this.props.message}
            </p>
            <div
              css={{
                display: 'flex',
                height: '50px',
                minWidth: '200px',
                justifyContent: 'space-between',
                visibility: this.props.hideActions ? 'hidden' : 'visible',
                ...(isMobile && { width: '90%' })
              }}
            >
              <DesktopView>
                {typeof this.props.onCancel === 'function' && (
                  <Button onClick={this.props.onCancel} bsStyle="default">
                    {this.props.cancelText}
                  </Button>
                )}
                {typeof this.props.onConfirm === 'function' && (
                  <Button onClick={this.props.onConfirm} bsStyle="warning">
                    {this.props.confirmText}
                  </Button>
                )}
              </DesktopView>
              <MobileView>
                <div className='columns-bottom-button-group'>
                  {typeof this.props.onCancel === 'function' && (
                    <button
                      onClick={this.props.onCancel}
                    >
                      {this.props.cancelText}
                    </button>
                  )}
                  {typeof this.props.onConfirm === 'function' && (
                    <button onClick={this.props.onConfirm}>
                      {this.props.confirmText}
                    </button>
                  )}
                </div>
              </MobileView>
            </div>
            {this.props.errorMessage && (
              <div
                css={{
                  position: 'absolute',
                  textAlign: 'center',
                  width: '100%',
                  bottom: '50px',
                  left: '0',
                  color: colors.lightRed,
                }}
              >
                {this.props.errorMessage}
              </div>
            )}
          </div>
        )}
      </MobileView>
    );
  }
}
